<template>
  <div
    v-show="value != null"
    class="py-3 flex text-sm"
    :class="{ 'border-b': show_border }"
    v-on:click="redirect"
  >
    <div class="flex-grow flex">
      <div class="h-icon w-icon mr-2">
        <img :src="require('@/assets/icons/' + icon)" />
      </div>
      <div
        class="flex-grow h-icon text-md pr-2 flex font-semibold justify-content items-center"
      >
        <span v-text="title"></span>
        <span v-show="required && type == 'to-do'" class="text-red">*</span>
      </div>
      <div
        class="text-sm h-icon truncate flex items-center"
        style="max-width: 160px"
      >
        <span v-if="type == 'profile'" class="truncate" v-text="value"></span>
        <img
          v-else-if="type == 'to-do'"
          class="h-icon w-icon"
          src="@/assets/icons/papsi_edit.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-info-bar-control",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
    },
    icon: {
      type: String,
    },
    show_border: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'profile',
    },
    required: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
    },
  },
  methods: {
    redirect() {
      if (this.href != null && this.type == 'to-do') {
        this.$router.push(this.href);
      }
    },
  },
};
</script>

<style scoped>
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
